var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-muted-lots"},[_vm._v(" Based on your browser telling us it's currently "+_vm._s(_vm.currentTimeFormatted)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }